import { render, staticRenderFns } from "./IdentiteitResultsBody.vue?vue&type=template&id=8caad12c&scoped=true&"
import script from "./IdentiteitResultsBody.vue?vue&type=script&lang=js&"
export * from "./IdentiteitResultsBody.vue?vue&type=script&lang=js&"
import style0 from "./IdentiteitResultsBody.vue?vue&type=style&index=0&id=8caad12c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caad12c",
  null
  
)

export default component.exports